import localforage from 'localforage'
import { sortBy, isEqual } from 'lodash'

let draggStore = localforage.createInstance({name: 'dataColumnDB'})
const ustr = () => Math.random().toString(36).substr(3)
const createUuid = () => ustr() + ustr()
const filterIter = (ele) => ele.key

const UNDRAGGABLE_FILTER = '.undraggable'

export const createUndraggabledIter = () => UNDRAGGABLE_FILTER

export function useDraggablePlugins (vm) {
  const storeDB = useDraggedLocalDataPlugins()
  const groupId = createUuid()
  const DRAGGABLE_OPTIONS = {
    group: 'kye-data-statistic-group-' + groupId,
    draggable: '.kye-data-statistic-cell',
    animation: 150,
    filter: UNDRAGGABLE_FILTER,
    // preventOnFilter: false,
    ghostClass: 'kye-data-statistic-ghost',

  }
  let beforeOptionList = null
  let beforeCellData = null

  const setDraggedDbItem = () => {
    const key = storeDB.DRAGGED_KEY
    const data = [...vm.cellData, ...vm.optionList]
    if (vm.$props.draggedId) {
      storeDB.setItem(vm.$props.draggedId + key, data.map(filterIter))
    } else {
      console.info('%c*****缺失唯一ID，失去拖拽记忆功能，拖拽后的数据：', 'color: red', data)
    }
  }
  const changeDraggingOptionList = (v) => {
    const length = vm.optionList.length
    if (length !== v.length) {
      vm.updateFlag('option')
      beforeOptionList = v
    } else {
      vm.updateOptionList(v)
    }
  }
  const dragingOptionListStart = (evt) => {
    vm.$parent.$emit('dragingCellDataStart', evt, vm.optionList)
  }
  const dragingOptionListEnd = (evt) => {
    // 拖拽数据存储
    setDraggedDbItem()
    vm.$parent.$emit('dragingOptionListEnd', evt, vm.optionList)
  }
  const changeDraggingCellData = (v) => {
    const length = vm.cellData.length
    if (v.length !== length) {
      vm.updateFlag('cell')
      beforeCellData = v
    } else {
      vm.updateCellData(v)
    }
  }
  const dragingCellDataStart = (evt) => {
    vm.$parent.$emit('dragingCellDataStart', evt, vm.cellData)
  }
  const dragingCellDataEnd = (evt) => {
    // 拖拽数据存储
    setDraggedDbItem()
    vm.$parent.$emit('dragingCellDataEnd', evt, vm.cellData)
  }

  // 处理拖拽中的数据
  const processingDraggingData = (val) => {
    if (val) {
      beforeOptionList && vm.updateOptionList(beforeOptionList)
      beforeCellData && vm.updateCellData(beforeCellData)
      if (val === 'cell') {
        // 从外面拖到里面
        const spliceItem = vm.optionList[0]
        // 里面的第一项移到外面的最后一项
        const optionList = vm.optionList.slice(1)
        vm.updateOptionList(optionList)
        const cellData = [...vm.cellData, spliceItem]
        vm.updateCellData(cellData)
      } else if (val === 'option') {
        // 里面拖到外面
        const spliceItem = vm.cellData[vm.cellData.length - 1]
        // 外面的最后一项移到里面的第一项
        const cellData = vm.cellData.slice(0, vm.cellData.length - 1)
        vm.updateCellData(cellData)
        const optionList = [spliceItem, ...vm.optionList]
        vm.updateOptionList(optionList)
      }
      vm.updateFlag(null)
      beforeCellData = null
      beforeOptionList = null
    }
  }

  // 获取历史拖拽的数据。并对比现有数据。合并或删除
  const compareCurrentDataWidthDbData = async (currentData) => {
    const draggedId = vm.$props.draggedId
    const historyKey = draggedId + storeDB.DRAGGED_KEY
    const historyData = await storeDB.getItem(historyKey)
    let equal = false
    let data = null
    if (historyData && historyData.length) {
      const _historyData = sortBy((historyData || []))
      const currentValue = sortBy(currentData.map(filterIter))
      equal = isEqual(_historyData, currentValue)
      if (equal) {
        console.info('%c*****使用本地的拖拽数据：', 'color: blue', historyData)
        // 应该重新分配
        data = historyData.map(key => currentData.find(ele => ele.key === key))
      } else {
        storeDB.removeItem(historyKey)
        console.log('------not-equl------')
      }
    }
    return {
      equal,
      data: data || currentData
    }
  }
  const watchManager = () => {
    vm.$watch('draggingMode', (val) => {
      processingDraggingData(val)
    })
  }

  const saveDefaultDbData = async () => {
    const draggedId = vm.$props.draggedId
    if (draggedId) {
      const data = await storeDB.getItem(draggedId + storeDB.DRAGGED_KEY)
      if (!data || !data.length) {
        setDraggedDbItem()
      }
    }
  }

  vm.$on('hook:mounted', async () => {
    watchManager()
    await saveDefaultDbData()
    const currentData = [...vm.$props.value]
    const { equal, data } = await compareCurrentDataWidthDbData(currentData)
    if (equal) {
      vm.updateCellData(data)
      vm.$nextTick(() => {
        vm.createRenderKeys(data)
      })
    }
  })


  return {
    DRAGGABLE_OPTIONS,
    changeDraggingOptionList,
    dragingOptionListStart,
    dragingOptionListEnd,
    changeDraggingCellData,
    dragingCellDataStart,
    dragingCellDataEnd,
    storeDB,
    compareCurrentDataWidthDbData
  }
}
const noop = (val) => val
function useDraggedLocalDataPlugins () {
  const DRAGGED_KEY = '_dragged_cell_option_data'
  const getItem = async (key, cb = noop) => {
    return draggStore.getItem(key, cb)
  }
  const setItem = async (key, val, cb = noop) => {
    return draggStore.setItem(key, val, cb)
  }
  const removeItem = async (key, cb = noop) => {
    return draggStore.removeItem(key, cb)
  }
  return {
    getItem,
    setItem,
    removeItem,
    DRAGGED_KEY,
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-data-statistic/plugins/draggable.js